hrd.utils.CompareUtils = hrd.Class.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.utils.CompareUtils',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	/**
	 * Given an arbitrary number of comparator functions, compose them when a comparator return 0
	 */
	compose: function() {
		const comparators = Array.prototype.slice.call(arguments, 0);
		let result = comparators.reduce((r, fn) => {
			if(r === 0) {
				r = fn();
			}
			return r;
		}, 0);
		return result;
	},
	/**
	 * Create a new no-args function that will be invoked for comparison as soon as is needed
	 */
	wrap: function(fn, c1, c2) {
		return () => fn.call(this, c1, c2);
	},
	compareStringsIgnoreCase: function(s1, s2) {
		return this.compareStrings(s1.toLowerCase(), s2.toLowerCase());
	},
	compareStrings: function(s1, s2) {
		if(s1 < s2) {
			return -1;
		} else if(s1 > s2) {
			return 1
		} else {
			return 0;
		}
	},
	compareNumbers: function(i1, i2) {
		if(i1 < i2) {
			return -1;
		} else if(i1 > i2) {
			return 1
		} else {
			return 0;
		}
	},
});

const compareUtils = new hrd.utils.CompareUtils();